import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {FormControl} from '@angular/forms';

const COUNTRY_API = 'https://demo-platform.int-eks-dev.shared-dev.eu-west-1.aws.clickatell.com/common-data/countries'

interface countryInfo {
  name: string,
  code: string
}

@Component({
  selector: 'app-country-select',
  templateUrl: './country-select.component.html',
  styleUrls: ['./country-select.component.scss']
})
export class CountrySelectComponent implements OnInit {
  @Input() countrySelect: FormControl;
  @ViewChild('countryFilter') countryFilter: ElementRef;
  constructor() { }

  codeCountries: countryInfo[];
  filteredCountries: any[];
  selectedCountry: string;
  selectedCode: string;
  showDropdown: boolean;

  ngOnInit(): void {
    this.getCountryCode();
    this.selectedCountry = this.countrySelect.value
  }

  getCountryCode() {
    fetch(COUNTRY_API)
        .then(response => response.json())
        .then(data => {
          this.codeCountries = data.map(country => ({
            code: country.isoCode2,
            name: country.name
          }));
          /*
          * Do not delete ONLY remove if the data is not being removed by the API
          * TODO: This needs to be removed when the 'Atlantis' is removed from the Prod API
          */
          if(this.codeCountries[14].name==='Atlantis')
            this.codeCountries.splice(14,1);
          this.filteredCountries = this.codeCountries.slice();

          const getCountry = (country: countryInfo): boolean => {
            if (this.selectedCountry) {
              return country.name === this.selectedCountry;
            }
            return false;
          };

          if (this.selectedCountry) {
            const selectedCountry: countryInfo = this.filteredCountries.find(getCountry);
            this.selectedCode = selectedCountry.code.toLowerCase();
          }

        })
        .catch(error => {
          console.error('Error:', error);
        });
  }

  selectCountry(country): void {
    this.selectedCountry = country.name;
    this.selectedCode = country.code.toLowerCase();
    this.countrySelect.setValue(country.name);
    this.showDropdown = false;
  }

  isSearch() {
    this.countryFilter.nativeElement.value = '';
    this.countrySelect.setValue('');
    this.selectedCode = '';
    this.filterCountries('');
  }

  filterCountries(searchValue: string) {
    if (searchValue.trim() !== '') {
      this.filteredCountries = this.codeCountries.filter(country =>
          country.name.toLowerCase().includes(searchValue.toLowerCase())
      );
    } else {
      this.filteredCountries = this.codeCountries.slice();
    }
  }

}
